export default [
  {
    header: 'Short Codes',
  },
  {
    icon: 'LogInIcon',
    title: 'Inbox',
    route: 'inbox',
  },
]
